import { Dispatch } from 'redux';
import {
  ADD_JOB,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAILURE,
  FETCH_JOBS,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE, MARK_JOB_NOTIFICATIONS_AS_SEEN,
} from './types';
import config, { jimJobConfigsByType } from '../../../config';

import type { Job } from '../../../menu/jobsMenu/types';
import {
  addJob as addJobApi,
  fetchJobStatuses as fetchJobStatusesApi,
  addJobOnMaster as addJobOnMasterApi,
} from '../api';
import createFormDataFromObject from '../../../utils/createFormDataFromObject';

type AddJobParams = {
  jobType: string,
  payload: Record<string, unknown>,
  onSuccess?: (job: Job) => unknown,
  onError?: (error: Error) => unknown,
}
export const addJob = ({
  jobType,
  payload,
  onSuccess = () => null,
  onError = () => null,
}: AddJobParams) => async (dispatch: Dispatch) => {
  dispatch({ type: ADD_JOB, jobType });
  const jobDisplayName = jimJobConfigsByType[jobType].displayName;

  try {
    const response = await addJobApi(jobType, createFormDataFromObject({
      ...payload,
      jobDisplayName: typeof jobDisplayName === 'function'
      // @ts-ignore
        ? jobDisplayName(payload)
        : jobDisplayName,
    }));
    dispatch({ type: ADD_JOB_SUCCESS, job: response });

    onSuccess(response);
  } catch (error) {
    dispatch({ type: ADD_JOB_FAILURE, jobType });

    onError(error as Error);
  }
};

type AddJobMasterParams = {
  jobType: string;
  enqueueJob: Record<string, unknown>;
  onSuccess?: (job: Job) => unknown;
  onError?: (error: Error) => unknown;
};
export const AddJobOnMaster = ({
  jobType,
  enqueueJob,
  onSuccess = () => null,
  onError = () => null,
}: AddJobMasterParams) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: ADD_JOB, jobType });

    try {
      const response = await addJobOnMasterApi(jobType, enqueueJob);
      dispatch({ type: ADD_JOB_SUCCESS, job: response });

      onSuccess(response);
    } catch (error) {
      dispatch({ type: ADD_JOB_FAILURE, jobType });

      onError(error as Error);
    }
  };

export const fetchJobs = (limit = config.defaultJobsLimit) => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_JOBS });
  try {
    const jobs = await fetchJobStatusesApi(limit);
    dispatch({ type: FETCH_JOBS_SUCCESS, jobs });
  } catch (error) {
    dispatch({ type: FETCH_JOBS_FAILURE });
  }
};

export const optimisticUpdateMarkJobNotificationsAsSeen = (jobIds: Job['jobId'][]) => ({
  type: MARK_JOB_NOTIFICATIONS_AS_SEEN,
  jobIds: new Set(jobIds),
});
